
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import GlobalState from '@/util/GlobalState';
import Organization from '@/api/mjegb/Organization';

@Component
export default class SaveDialog extends Vue {
    @Prop({ type: Boolean, required: false, default: false })
    public readonly value!: boolean;

    public name = '';
    public organization: number | null = null;

    public get organizations(): Organization[] {
        return this.globalState?.currentUser?.organizations || [];
    }

    @Inject()
    private readonly globalState!: GlobalState;

    public onSave(): void {
        this.onClose();
        this.$emit('save-as', { name: this.name, organization: this.organization });
    }

    public onClose(): void {
        this.$emit('input', false);
    }
}
